import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = { style: {"margin-bottom":"20px","max-height":"120px","overflow":"auto"} }
const _hoisted_7 = {
  key: 0,
  class: "checkbox-input"
}
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { style: {"margin-bottom":"20px","max-height":"120px","overflow":"auto"} }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "checkbox-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      (!_ctx.$props.user)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Phone"))
        : _createCommentVNode("", true),
      (!_ctx.$props.user)
        ? (_openBlock(), _createBlock(_component_phone_input, {
            key: 1,
            modelValue: _ctx.formData.Phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Phone) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.isNew)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "New Password", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              autocomplete: "new-password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.Password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.formData.Password]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"margin-bottom":"15px","font-size":"13px","opacity":"0.7"} }, "Leave blank to keep the current password", -1))
          ], 64))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createElementVNode("h3", null, "First Name", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.FirstName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.formData.FirstName]
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Last Name", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.LastName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.formData.LastName]
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Location", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.Location) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (location, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: location
          }, _toDisplayString(location), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.formData.Location]
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Additional Locations", -1)),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.AdditionalLocationsNew, (location, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (location.name != _ctx.formData.Location)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((location.isChecked) = $event)
                  }, null, 8, _hoisted_8), [
                    [_vModelCheckbox, location.isChecked]
                  ]),
                  _createElementVNode("div", null, _toDisplayString(location.name), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Departments", -1)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.DepartmentsNew, (department, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "checkbox-input"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": ($event: any) => ((department.isChecked) = $event)
            }, null, 8, _hoisted_10), [
              [_vModelCheckbox, department.isChecked]
            ]),
            _createElementVNode("div", null, _toDisplayString(department.name), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.InActive) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.formData.InActive]
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("h3", { style: {"margin":"0"} }, "Inactive?", -1))
      ]),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Submit",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ])
  ]))
}